import React, { useEffect, useState } from 'react'
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Paper, Divider, Stack, CircularProgress, Tooltip } from "@mui/material";
import axios from "../../../utils/fvAxios";
import ButtonV1 from "../../../toolkit/ButtonV1";
import Upload from "../../../icons/Upload";
import InfoIcon from "../../../icons/informationIcon.svg";

function ActiveSubscription({ SubscriptionInfo }) {

    const ActiveSubscription = SubscriptionInfo != null ? SubscriptionInfo : null;
    const oneYearLater = ActiveSubscription?.paymentReceivedDate
        ? new Date(new Date(ActiveSubscription?.paymentReceivedDate).setFullYear(
            new Date(ActiveSubscription?.paymentReceivedDate).getFullYear() + 1
        )).toISOString().split("T")[0]
        : null;

    // const activeList = SubscriptionInfo?.filter(x => x.isActive === true);

    // const ActiveSubscription =
    //     activeList?.length > 0
    //         ? activeList.reduce((oldest, current) =>
    //             new Date(current.paymentReceivedDate) <
    //                 new Date(oldest.paymentReceivedDate)
    //                 ? current
    //                 : oldest
    //         )
    //         : null;


    const [fileContent, setFileContent] = useState({});
    const [isReceiptLoading, setIsReceiptLoading] = useState(false);

    const handleReceiptDownload = (data) => {
        setIsReceiptLoading(true);
        axios.get("Prequalification/DownloadSubscriptionFeePaymentReceipt?vendorMembershipPaymentId=" + data?.vendorMembershipPaymentId +
            "&vendorMembershipSpecificPeriodPaymentsId=" + data?.vendorMembershipSpecificPeriodPaymentsId + "&vendorId=" + data?.vendorId, {
            responseType: "blob",
        }).then((res) => {
            if (res?.data) {
                if (res?.data instanceof Blob) {
                    const file = new Blob([res?.data], { type: "application/pdf" });
                    const fileURL = URL?.createObjectURL(file);
                    const pdfWindow = window?.open();
                    pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');
                    setIsReceiptLoading(false);
                } else {
                    console.error("Unexpected response format");
                }
            }
            setFileContent(res);
        }).catch((err) => {
            setIsReceiptLoading(false);
            console.error(err);
        }).finally(() => {
            setIsReceiptLoading(false);
        });
    };
    return (
        <div>
            <Box border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec"
                className="mt-2"
                sx={{ background: "#fff", marginBottom: "10px" }}>
                <Stack spacing={2} direction="row">
                    <h2 style={{ padding: "10px", marginTop: "12px", float: "left" }}>
                        Active Subscription Details
                    </h2>
                </Stack>
                <Divider sx={{ backgroundColor: "#667085", height: "2px" }} />
                <TableContainer component={Paper}>
                    <p hidden={ActiveSubscription != null} style={{ fontSize: "15px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px", textAlign: "center" }}>
                        No Active Subscription Details
                    </p>
                    <Table sx={{ minWidth: 1000 }} aria-label="simple table" hidden={ActiveSubscription == null}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Transaction ID</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Received Date</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Valid Till</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Amount </TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }} align="right">Receipt </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow
                                key={ActiveSubscription?.paymentTransactionId}
                                sx={{
                                    "& td, & th": {
                                        borderBottom: "1px solid #E0E0E0"
                                    },
                                    "&:last-child td, &:last-child th": {
                                        borderBottom: "1px solid #E0E0E0" // keep last row visible too
                                    }
                                }}
                            >
                                <TableCell style={{ fontSize: "13px" }}>{ActiveSubscription?.paymentTransactionId}</TableCell>
                                <TableCell style={{ fontSize: "13px" }}>{GetfVDateFormate("", ActiveSubscription?.paymentReceivedDate)}</TableCell>
                                <TableCell style={{ fontSize: "13px" }}>{GetfVDateFormate("", oneYearLater)}</TableCell>
                                <TableCell style={{ fontSize: "13px" }}>${ActiveSubscription?.paymentReceivedAmount}</TableCell>
                                <TableCell style={{ fontSize: "13px" }} align="right">
                                    <ButtonV1
                                        className="border-0"
                                        role="tertiary"
                                        variant="outlined"
                                        id="menu_btn"
                                        style={{
                                            height: "36px",
                                            color: "var(--blue50)",
                                        }}
                                        trailingComponent={
                                            isReceiptLoading ? (
                                                <CircularProgress size={20} />
                                            ) : (
                                                <Upload stroke="var(--blue50)" />
                                            )
                                        }
                                        onClick={() => handleReceiptDownload(ActiveSubscription)}
                                    />
                                    {/* <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            minHeight: "36px" 
                                        }}
                                    >
                                        {!ActiveSubscription?.paymentTransactionId ? (
                                            <Tooltip
                                                title="This is a skipped payment. Receipt is not available."
                                                placement="top"
                                            >
                                                <span
                                                    style={{
                                                        width: "36px",
                                                        height: "36px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <img
                                                        src={InfoIcon}
                                                        alt="Info"
                                                        style={{
                                                            width: "16px",
                                                            height: "16px"
                                                        }}
                                                    />
                                                </span>
                                            </Tooltip>
                                        ) : (
                                           
                                        )}
                                    </div> */}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <TableContainer
                    component={Paper}
                    className='mt-3'
                    sx={{
                        boxShadow: `0px -4px 8px rgba(0,0,0,0.15),0px 4px 8px rgba(0,0,0,0.15) `
                    }}>
                    <Stack spacing={2} direction="row">
                        <h2 style={{ padding: "10px", marginTop: "12px", float: "left" }}>
                            Subscription Fee FAQ's
                        </h2>
                    </Stack>
                    <Divider sx={{ backgroundColor: "#667085", height: "2px" }} />

                    <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
                        <b> Q) What is a subscription fee?</b><br />
                        A) This is a recurring annual payment to support the ongoing maintenance, security, and reliability of the <b>FIRST</b>, VERIFY platform, and is not associated with any individual hiring client.
                    </p>

                    <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
                        <b> Q) When is the payment due?</b><br />
                        A) The subscription fee will be added to your first prequalification fee each year, and renewed no more frequently than every 12 months.
                    </p>

                    <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px" }}>
                        <b> Q) Can I get a receipt for the payment?</b><br />
                        A) Yes, a receipt for your current subscription can be found on the Subscription Fee page (under your Account Menu).
                    </p>
                </TableContainer>
            </Box >
        </div >
    )
}

export default ActiveSubscription